import { Home } from 'react-feather';
import { BiTransfer } from 'react-icons/bi';
import {
  BsFillPeopleFill,
  BsBank,
  BsGraphUp,
  BsBox,
  BsGear,
} from 'react-icons/bs';
import {
  FaCalculator,
  FaLink,
  FaLock,
  FaMoneyCheckAlt,
  FaRegBuilding,
  FaStore,
  FaUserFriends,
  FaUsers,
  FaUser,
  FaUsersCog,
  FaCog,
  FaHandsHelping,
  FaListUl,
} from 'react-icons/fa';
import { FiShield } from 'react-icons/fi';
import { AiFillDollarCircle } from 'react-icons/ai';
import { GiTakeMyMoney } from 'react-icons/gi';
import { HiDocumentReport, HiOutlineCurrencyDollar } from 'react-icons/hi';
import { IoMdArchive } from 'react-icons/io';
import { IoCreateOutline } from 'react-icons/io5';
import {
  MdAnalytics,
  MdManageAccounts,
  MdOutlineReceiptLong,
  MdPayment,
  MdPayments,
} from 'react-icons/md';
import { SiHomeassistantcommunitystore } from 'react-icons/si';

export default [
  {
    id: 'analytics',
    title: 'Indicadores',
    icon: <BsGraphUp size={20} />,
    action: 'view_analytics',
    resource: 'ACL',
    navLink: '/dashboard/analytics',
  },

  {
    // Changing only the Dashboard label to Analytics, due to the concept of the reports.
    id: 'dashboard',
    title: 'Analytics',
    icon: <Home size={20} />,
    action: 'view_analytics_dashboard',
    resource: 'ACL',
    navLink: '/dashboard/ecommerce',
  },

  {
    id: 'analyticsCompanies',
    title: 'Analítico',
    icon: <MdAnalytics size={20} />,
    action: 'view_analytics_whitelabel',
    resource: 'ACL',
    navLink: '/dashboard/analytics/companies',
  },
  {
    id: 'transactions',
    title: 'Transações',
    icon: <AiFillDollarCircle size={20} />,
    children: [
      {
        id: 'bankingActivity',
        title: 'Extrato Bancário',
        icon: <BsBank size={20} />,
        action: 'view_bank_statement',
        resource: 'ACL',
        navLink: '/dashboard/BankingActivity',
      },
      {
        id: 'statements',
        title: 'Extratos',
        icon: <MdOutlineReceiptLong size={20} />,
        action: 'view_statements',
        resource: 'ACL',
        navLink: '/dashboard/statements',
      },
      {
        id: 'transfers',
        title: 'Transferências',
        icon: <BiTransfer size={20} />,
        action: 'view_transfers',
        navLink: '/dashboard/transfers',
      },
      {
        id: 'payments',
        title: 'Transações Financeiras',
        icon: <MdPayments size={20} />,
        action: 'view_transactions',
        resource: 'ACL',
        navLink: '/dashboard/transactions',
      },
      {
        id: 'reports',
        title: 'Relatórios',
        icon: <HiDocumentReport size={20} />,
        action: 'view_analytics',
        resource: 'ACL',
        navLink: '/dashboard/reports',
      },
      {
        id: 'exchange-conciliation',
        title: 'Conciliação de Câmbio',
        icon: <FaCalculator size={20} />,
        action: 'view_conciliate_exchange_transactions',
        resource: 'ACL',
        navLink: '/dashboard/exchange/conciliation/create',
      },
    ],
  },
  {
    id: 'partners',
    title: 'White Label e Lojas',
    icon: <FaHandsHelping size={20} />,
    action: 'view_establishments',
    resource: 'ACL',
    children: [
      {
        id: 'customers',
        title: 'White Label',
        icon: <FaUsers size={20} />,
        action: 'view_customers',
        resource: 'ACL',
        navLink: '/dashboard/customers',
      },
      {
        id: 'establishments',
        title: 'Lojas',
        icon: <SiHomeassistantcommunitystore size={20} />,
        action: 'view_establishments',
        resource: 'ACL',
        navLink: '/dashboard/establishments',
      },
    ],
  },
  {
    id: 'anticipations',
    title: 'Antecipações',
    icon: <GiTakeMyMoney size={20} />,
    action: 'view_anticipations',
    resource: 'ACL',
    navLink: '/dashboard/anticipations',
  },
  {
    id: 'products',
    title: 'Produtos',
    icon: <BsBox size={20} />,
    children: [
      {
        id: 'payment-links',
        title: 'Links de Pagamento',
        icon: <FaLink size={20} />,
        children: [
          {
            id: 'link-unique',
            title: 'Personalizado',
            icon: <FaLink size={20} />,
            action: 'view_links',
            resource: 'ACL',
            navLink: '/dashboard/payment/links',
          },
          {
            id: 'link-fixed',
            title: 'Anônimo',
            icon: <FaLink size={20} />,
            action: 'view_links',
            resource: 'ACL',
            navLink: '/dashboard/payment/links/fixed',
          },
        ],
      },
      {
        id: 'recurrences',
        title: 'Recorrências',
        icon: <MdPayment size={20} />,
        action: 'view_recurrences',
        resource: 'ACL',
        children: [
          {
            id: 'unique-recurrences',
            title: 'Personalizado',
            icon: <MdPayment size={20} />,
            action: 'view_recurrences',
            resource: 'ACL',
            navLink: '/dashboard/recurrences',
          },
          {
            id: 'fixed-recurrences',
            title: 'Anônimo',
            icon: <MdPayment size={20} />,
            action: 'view_recurrences',
            resource: 'ACL',
            navLink: '/dashboard/fixed/recurrences',
          },
        ],
      },

      {
        id: 'debt-simulator',
        title: 'Simulação',
        icon: <FaCalculator size={20} />,
        action: 'view_simulator',
        resource: 'ACL',
        navLink: '/dashboard/simulator',
      },
    ],
  },
  {
    id: 'onboarding',
    title: 'OnBoarding',
    icon: <FaUsers size={20} />,
    action: 'view_menu_onboarding',
    resource: 'ACL',
    children: [
      {
        id: 'create-company',
        title: 'Criar Empresa',
        icon: <IoCreateOutline size={20} />,
        action: 'view_onboarding_create_company',
        resource: 'ACL',
        navLink: '/dashboard/establishments/create',
      },
      {
        id: 'all-invites',
        title: 'Convites',
        icon: <FaUserFriends size={20} />,
        action: 'view_onboarding_invites',
        resource: 'ACL',
        navLink: '/dashboard/onboarding/invitesOperators',
      },
      {
        id: 'all-companys',
        title: 'Análise',
        icon: <FaRegBuilding size={20} />,
        action: 'view_onboarding_companies',
        resource: 'ACL',
        navLink: '/dashboard/onboarding',
      },
      {
        id: 'list-pre-registrations',
        title: 'Pré-Registros',
        icon: <FaListUl size={20} />,
        action: 'view_dashboard',
        resource: 'ACL',
        navLink: '/dashboard/onboarding/pre-registro',
      },
    ],
  },
  {
    id: 'account-settings',
    title: 'Minha Conta',
    icon: <FaUser size={20} />,
    children: [
      {
        id: 'my-rates',
        title: 'Minhas Taxas',
        icon: <HiOutlineCurrencyDollar size={20} />,
        action: 'view_my_rates',
        resource: 'ACL',
        navLink: '/dashboard/myrates',
      },
      {
        id: 'my-account',
        title: 'Meus Dados',
        icon: <MdManageAccounts size={20} />,
        action: 'view_my_account',
        resource: 'ACL',
        navLink: '/dashboard/myaccount',
      },
    ],
  },

  {
    id: 'operators-users',
    title: 'Operadores',
    icon: <BsFillPeopleFill size={20} />,
    action: 'view_operators_users',
    resource: 'ACL',
    navLink: '/dashboard/operators',
  },

  {
    id: 'functions',
    title: 'Sistema',
    icon: <BsGear size={20} />,
    children: [
      {
        id: 'users',
        title: 'Usuários',
        icon: <FaUsersCog size={20} />,
        action: 'view_users',
        resource: 'ACL',
        navLink: '/dashboard/list/users',
      },
      {
        id: 'roles',
        title: 'Funções',
        icon: <FiShield size={20} />,
        action: 'view_roles',
        resource: 'ACL',
        navLink: '/dashboard/roles',
      },
      {
        id: 'permissions',
        title: 'Permissões',
        icon: <FaLock size={20} />,
        action: 'view_permissions',
        resource: 'ACL',
        navLink: '/dashboard/list/permissions',
      },
      {
        id: 'system',
        title: 'Configurações de ambiente',
        icon: <FaCog size={20} />,
        action: 'view_system',
        resource: 'ACL',
        navLink: '/dashboard/system',
      },
    ],
  },
  {
    id: 'OnRegister',
    title: 'Criar Loja',
    icon: <FaStore size={20} />,
    action: 'create_company_onboarding_wizard',
    resource: 'ACL',
    navLink: '/dashboard/onboarding/company/wizard',
  },

  {
    id: 'edi-adiq',
    title: 'Edi Adiq',
    icon: <MdAnalytics size={20} />,
    action: 'view_edi_adiq',
    resource: 'ACL',
    navLink: '/dashboard/ediadiq',
  },
  {
    id: 'edi-global',
    title: 'Edi Global',
    icon: <MdAnalytics size={20} />,
    action: 'view_edi_global',
    resource: 'ACL',
    navLink: '/dashboard/ediglobal',
  },
  {
    id: 'exported-files',
    title: 'Arquivos',
    icon: <IoMdArchive size={20} />,
    action: 'view_exported_files',
    resource: 'ACL',
    navLink: '/dashboard/exported-files',
  },
  {
    id: 'standard-rates',
    title: 'Tarifas Padrão',
    icon: <FaMoneyCheckAlt size={20} />,
    action: 'view_standard_rates',
    navLink: '/rates/standard',
  },

  {
    id: 'fee-simulator',
    title: 'Simular Proposta',
    icon: <FaCalculator size={20} />,
    action: 'view_fee_simulator',
    resource: 'ACL',
    navLink: '/dashboard/simulator/fee',
  },
  {
    id: 'conciliations',
    title: 'Conciliação',
    icon: <FaCalculator size={20} />,
    action: 'view_conciliations',
    resource: 'ACL',
    navLink: '/dashboard/conciliations',
  },
];
